var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import uniqid from 'uniqid';
export var SET_MODAL = '@notifications/SET_MODAL';
export var setModalAction = function (actionPayload) { return ({
    type: SET_MODAL,
    payload: __assign(__assign({}, actionPayload), { id: uniqid('notification_') }),
}); };
export var REMOVE_MODAL = '@notifications/REMOVE_MODAL';
export var removeModalAction = function (payload) { return ({
    type: REMOVE_MODAL,
    payload: payload,
}); };
export var REMOVE_ALL_MODALS = '@notifications/REMOVE_ALL_MODALS';
export var removeAllModalsAction = function () { return ({
    type: REMOVE_ALL_MODALS,
}); };
